import React from 'react';
import { Link } from 'react-router';
import scrollTo from 'scroll-to-element';

export default ({ to, onRequestClose, hash, openEditDialog }) => to ? (
  (<Link style={{ fontSize: '14px', marginLeft: '8px', color: '#00bcd4', cursor: 'pointer' }} to={to} onClick={() => {
    onRequestClose('');
    const scrollToAnchor = () => {
      const element = document.querySelector(hash);
      if (element) scrollTo(hash, { offset: -70 });
    };
    scrollToAnchor();
  }}
  >
    Edit
  </Link>)
) : (
  (<span style={{ fontSize: '14px', marginLeft: '8px', color: '#00bcd4', cursor: 'pointer' }} onClick={() => {
    onRequestClose('');
    const scrollToAnchor = () => {
      const element = document.querySelector(hash);
      if (element) scrollTo(hash, { offset: -70 });
    };
    scrollToAnchor();
    openEditDialog();
  }}
  >
    Edit
  </span>)
);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/progressIndicatorBar/check-your-progress/edit-link.jsx